// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  period: __t.string(),
  renderMinutes: __t.f64().name("render_minutes"),
  aiMinutes: __t.f64().name("ai_minutes"),
  bonusRenderMinutes: __t.f64().name("bonus_render_minutes"),
  exports: __t.u32(),
  workerSeconds: __t.f64().name("worker_seconds"),
  gpuSeconds: __t.f64().name("gpu_seconds"),
  updatedAt: __t.timestamp().name("updated_at"),
});
